<script lang="ts">
	import Checkmark from '$lib/icons/checkmark.svelte';
	import StarRating from '$lib/review/starRating.svelte';
	import type { Review } from '$lib/types/yotpo';
	import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';

	interface Props {
		review: Review;
		showSpeechMarks?: boolean;
		class?: string;
	}

	let { review, showSpeechMarks = false, class: className }: Props = $props();
</script>

<div class="flex flex-col gap-y-4 rounded-2xl {className || ''}">
	<div class="flex justify-between">
		<StarRating starClass="h-6 w-6" score={review.score} totalStars={5} />
		{#if review.created_at}
			<p class="text-[14px]/[160%] text-brown-1/60 lg:text-[16px]/[150%]">
				{formatDistanceToNow(new Date(review.created_at), { addSuffix: true })}
			</p>
		{/if}
	</div>

	<p
		class="flex text-[16px]/[150%] text-brown-1 max-lg:tracking-[-.16px]"
		class:-translate-x-[6px]={showSpeechMarks}
	>
		{#if showSpeechMarks}
			<span>“</span>
		{/if}
		<span>
			{@html review.content}
			{showSpeechMarks ? '”' : ''}
		</span>
	</p>

	<div class="flex items-center gap-x-3">
		<div
			class="relative flex h-9 w-9 items-center justify-center rounded-full bg-brown-1 text-white"
		>
			{review.user.display_name.charAt(0)}

			<div
				class="absolute bottom-0 right-0 flex h-5 w-5 translate-x-1 translate-y-1 items-center justify-center rounded-full border border-white bg-green-4"
			>
				<Checkmark class="h-[14px] w-[14px]" />
			</div>
		</div>

		<div class="text-brown-1">
			<p class="text-[14px]/[130%] tracking-[-.28px]">{review.user.display_name}</p>
			{#if review.verified_buyer}
				<p class="text-[14px]/[112%] opacity-60 max-lg:tracking-[.12px] lg:text-[14px]/[160%]">
					Verified buyer
				</p>
			{/if}
		</div>
	</div>
</div>
